function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 0.5C3.58 0.5 0 4.08 0 8.5C0 12.04 2.29 15.03 5.47 16.09C5.87 16.16 6.02 15.92 6.02 15.71C6.02 15.52 6.01 14.89 6.01 14.22C4 14.59 3.48 13.73 3.32 13.28C3.23 13.05 2.84 12.34 2.5 12.15C2.22 12 1.82 11.63 2.49 11.62C3.12 11.61 3.57 12.2 3.72 12.44C4.44 13.65 5.59 13.31 6.05 13.1C6.12 12.58 6.33 12.23 6.56 12.03C4.78 11.83 2.92 11.14 2.92 8.08C2.92 7.21 3.23 6.49 3.74 5.93C3.66 5.73 3.38 4.91 3.82 3.81C3.82 3.81 4.49 3.6 6.02 4.63C6.66 4.45 7.34 4.36 8.02 4.36C8.7 4.36 9.38 4.45 10.02 4.63C11.55 3.59 12.22 3.81 12.22 3.81C12.66 4.91 12.38 5.73 12.3 5.93C12.81 6.49 13.12 7.2 13.12 8.08C13.12 11.15 11.25 11.83 9.47 12.03C9.76 12.28 10.01 12.76 10.01 13.51C10.01 14.58 10 15.44 10 15.71C10 15.92 10.15 16.17 10.55 16.09C12.1381 15.5538 13.5181 14.5331 14.4958 13.1716C15.4734 11.81 15.9995 10.1762 16 8.5C16 4.08 12.42 0.5 8 0.5Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0 0.5)"
})));

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.665de584.svg";
export { ForwardRef as ReactComponent };